import { render, staticRenderFns } from "./DepositSubscriptionCardContainer.vue?vue&type=template&id=8a66e728&"
import script from "./DepositSubscriptionCardContainer.vue?vue&type=script&lang=js&"
export * from "./DepositSubscriptionCardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports